import * as Sentry from '@sentry/react';
import { env } from '../config/env';

/** Starts Sentry when a DSN is configured; traces propagate to same-origin /api calls. */
export function initSentry() {
  if (!env.sentryDsn) return;
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.appEnv,
    release: env.appVersion,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: env.appEnv === 'production' ? 0.2 : 1.0,
    tracePropagationTargets: [/^\/api\//, new RegExp(`^${window.location.origin}/api/`)],
    sendDefaultPii: false,
  });
}
